export default {
    methods: {
      gameInit(list) {
        this.setGameTag(list);
        this.setGameStar(list);
        return list;
      },
      /**
       * 处理游戏标签和开服信息显示
       */
      setGameTag(list) {
        list.forEach((g) => {
          let formatGameType = [];
          if (g.gameType && g.gameType.length) {
            let isBTgame = g.gameType.includes("BT游戏");
            let hasKouBeiBangTag = g.gameType.includes("口碑榜");
            let hasTeJiaTag = g.gameType.includes("特价");
            g.isBTgame = isBTgame;
            if (hasKouBeiBangTag && hasTeJiaTag) {
              formatGameType.push("口碑榜");
              formatGameType.push("特价");
            } else if (!hasKouBeiBangTag && !hasTeJiaTag) {
              formatGameType.push(...g.gameType.slice(0, 2));
            } else if (hasKouBeiBangTag || hasTeJiaTag) {
              if (hasKouBeiBangTag) {
                formatGameType.push("口碑榜");
              }
              if (hasTeJiaTag) {
                formatGameType.push("特价");
              }
              if (g.gameType.length > 0) {
                let filterArr = g.gameType.filter(
                  (e) => e != "口碑榜" && e != "特价"
                );
                formatGameType.push(filterArr[0]);
              }
            }
          }
          g.formatGameType = formatGameType;
        });
        return list;
      },
  
      /**
       * 处理游戏星标
       */
      setGameStar(list) {
        list.forEach((k) => {
          let level = Number(k.gamehotlevel);
          if (level == 0) {
            //不设置
            k.starInfo = {}
          } else if (level == 1) {
            k.starInfo = { allStar: 0, halfStar: 1 };
          } else if (level == 2) {
            k.starInfo = { allStar: 1, halfStar: 0 };
          } else if (level == 3) {
            k.starInfo = { allStar: 1, halfStar: 1 };
          } else if (level == 4) {
            k.starInfo = { allStar: 2, halfStar: 0 };
          } else if (level == 5) {
            k.starInfo = { allStar: 2, halfStar: 1 };
          } else {
            k.starInfo = { allStar: 3, halfStar: 0 };
          }
        });
        return list;
      },
    }
  }


// WEBPACK FOOTER //
// ./src/mixin/game.js